import { MissingReplacementsError, replace } from '@change-corgi/core/i18n';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfSharePageFcmExperiments } from 'src/app/pages/psf/share/pageContext';

import { useReplacements } from '../usePageCopy/useReplacements';

export function useWhatsappShareMessage(): string | undefined {
	const {
		whatsAppExperiment: {
			variation,
			fcm: { config },
		},
	} = usePsfSharePageFcmExperiments();
	const {
		data: { replacements },
	} = useReplacements();

	const {
		errorReporter: { report },
	} = useUtilityContext();

	if (variation === 'control' || variation === 'fake_control') {
		return undefined;
	}

	const variationData = config.variants[variation as keyof typeof config.variants];

	if (!variationData?.message) return undefined;

	try {
		return replace(variationData.message, replacements);
	} catch (e) {
		if (e instanceof MissingReplacementsError) {
			void report({
				error: e,
				params: { page: 'psf/share', variant: variation },
			});
			return e.finalTranslation;
		}
		return undefined;
	}
}
